import BaseView from '../base-view';

export default BaseView.extend({
	events: {
		'change input[name="toggle-all"]': 'onClickToggleAll'
	},

	initialize: function() {
		// reference to all other checkboxes
		this.checkboxes = this.queryAll('input[name="participantIds"]');
	},

	// toggle handler
	onClickToggleAll: function(e) {
		var checked = e.currentTarget.checked;

		this.toggleAll(checked);
	},

	// check or uncheck all checkboxes
	toggleAll: function(checked) {
		this.checkboxes.forEach(function(checkbox) {
			checkbox.checked = checked;
		});
	}
});
